import * as betprofessor from './Form.styles.betprofessor';
import * as fiestabet from './Form.styles.fiestabet';
import * as sugarcastle from './Form.styles.sugarcastle';
import * as oldgill from './Form.styles.oldgill';
import * as buffalobet from './Form.styles.buffalobet';
import * as bet777 from './Form.styles.bet777';
import * as goldenrush from './Form.styles.goldenrush';
import * as juicybet from './Form.styles.juicybet';
import * as junglebet from './Form.styles.junglebet';
import * as betroyale from './Form.styles.betroyale';
import * as titanbet from './Form.styles.titanbet';
import * as gigabet from './Form.styles.gigabet';
import * as slambet from './Form.styles.slambet';
import * as betstride from './Form.styles.betstride';
import * as templebet from './Form.styles.templebet';
import * as goldenbet888 from './Form.styles.goldenbet888';
import * as hyperbet from './Form.styles.hyperbet';
import * as chromabet from './Form.styles.chromabet';
import * as bet575 from './Form.styles.bet575';
import * as epicodds from './Form.styles.epicodds';
import * as pyramidbet from './Form.styles.pyramidbet';
import * as magnumbet from './Form.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betroyale,
  betprofessor,
  fiestabet,
  sugarcastle,
  oldgill,
  buffalobet,
  bet777,
  goldenrush,
  juicybet,
  junglebet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
